<template>
  <div>
    <!-- Fila 1 — Seguro de vida ley -->
    <div class="flex flex-wrap -mx-2 items-start">
      <div class="w-full md:w-1/2 mb-3 px-2">
        <div class="flex items-center mt-2">
          <label class="wz-form-label mb-0 mr-3">Seguro de vida ley</label>
          <wz-checkbox v-model="form.hasLifeInsurance" name="hasLifeInsurance" switch size="lg" />
        </div>
      </div>
      <div class="w-full md:w-1/2 mb-3 px-2" v-if="form.hasLifeInsurance">
        <wz-input
          label="Número de póliza vida ley"
          v-model="form.lifeInsurancePolicy"
          placeholder="Ingresar número de póliza"
        />
      </div>
    </div>

    <!-- Fila 2 — SCTR Pensión -->
    <div class="flex flex-wrap -mx-2 items-start">
      <div class="w-full md:w-1/2 mb-3 px-2">
        <div class="flex items-center mt-2">
          <label class="wz-form-label mb-0 mr-3">SCTR Pensión</label>
          <wz-checkbox v-model="form.hasSctrPension" name="hasSctrPension" switch size="lg" />
        </div>
      </div>
      <div class="w-full md:w-1/2 mb-3 px-2" v-if="form.hasSctrPension">
        <wz-input
          label="Número de póliza SCTR Pensión"
          v-model="form.sctrPensionPolicy"
          placeholder="Ingresar número de póliza"
        />
      </div>
    </div>

    <!-- Fila 3 — SCTR Salud -->
    <div class="flex flex-wrap -mx-2 items-start">
      <div class="w-full md:w-1/2 mb-3 px-2">
        <div class="flex items-center mt-2">
          <label class="wz-form-label mb-0 mr-3">SCTR Salud</label>
          <wz-checkbox v-model="form.hasSctrHealth" name="hasSctrHealth" switch size="lg" />
        </div>
      </div>
      <div class="w-full md:w-1/2 mb-3 px-2" v-if="form.hasSctrHealth">
        <wz-input
          label="Número de póliza SCTR Salud"
          v-model="form.sctrHealthPolicy"
          placeholder="Ingresar número de póliza"
        />
      </div>
    </div>

    <!-- Nota legal SCTR Salud: siempre visible (reemplaza el tooltip, fácil de perder) -->
    <wz-alert variant="info" icon="ri-information-line" class="mb-3">
      Si el contrato tiene SCTR, los accidentes laborales van directo a subsidio EsSalud desde el día 1.
      Si no, se tratan como enfermedad común (primeros 20 días a cargo del empleador + subsidio desde el día 21).
    </wz-alert>

    <!-- Fila 4 — EPS -->
    <div class="flex flex-wrap -mx-2 items-start">
      <div class="w-full md:w-1/2 mb-3 px-2">
        <div class="flex items-center mt-2">
          <label class="wz-form-label mb-0 mr-3">Tiene EPS</label>
          <wz-checkbox v-model="form.hasEps" name="hasEps" switch size="lg" />
        </div>
      </div>
      <div class="w-full md:w-1/2 mb-3 px-2" v-if="form.hasEps">
        <wz-input
          label="Entidad EPS"
          v-model="form.epsEntity"
          placeholder="Ingresar entidad EPS"
        />
      </div>
    </div>

    <hr class="my-3" />

    <!-- Código EsSalud (campo suelto) -->
    <div class="flex flex-wrap -mx-2">
      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Código EsSalud"
          v-model="form.essaludCode"
          placeholder="Ingresar código EsSalud"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: { type: Object, required: true },
    v:    { type: Object, required: true },
  },
}
</script>

<style lang="stylus" scoped></style>
